<template>
    <div id="body-wrap" class="">
        <IndicatorDetailHeader v-if="isDetail"/>
        <LayoutHeader v-show="!isDetail"/>
        <Main />
        <Footer />
        <FooterPc />
        <Common />
        <!-- 심플맵 마커 상세팝업 -->
        <div id="layer-popup-div" style="display: none; position: absolute; z-index: 10000"></div>
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import IndicatorDetailHeader from '@/views/indicator/IndicatorDetailHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Main from '@/views/main/Main.vue';
import Common from '@/views/common/Common.vue';

import gripUtil from "@/libs/grip.util";
import { mapGetters } from 'vuex';
import {$_TYPE, $_CD} from '@/confs/common.const';
import { defualtMeta } from '@/confs/vue.meta';

export default {
    metaInfo: {
        meta: defualtMeta,
    },
    components: {
        LayoutHeader,
        IndicatorDetailHeader,
        Footer,
        FooterPc,
        Main,
        Common,
    },
    computed: {
        ...mapGetters({
            ssovDeptList : 'getSsovDeptList',
            bizList : 'getBizList',
            isDetail: 'getIsDetail',
        }),
    },
    created() {
        // 실시간 데이터 get
        this.getRealtimeData();
        setInterval(()=>{
            this.getRealtimeData();
        }, 1000 * 60 * 10);

        let proms = [];
        proms.push(this.$store.dispatch('FETCH_INDICATOR_CATE_LIST'));
        Promise.all(proms).then(()=>{
            this.$store.dispatch('SET_SELECTED_INDICATOR_CATE', '')
        });
        // this.$store.dispatch('FETCH_INDICATOR_LATESTED_IDX_LIST', 'mngTblSqno=11&maxLimit=6&openYn=1');
        this.$store.dispatch('FETCH_INDICATOR_IDX_LIST', 'openYn&=1');

        this.$store.dispatch('FETCH_READ_LIST');

        //정책 강남
        this.$store.dispatch('FETCH_PROMIMSE_FIELD_CODE_LIST');
        this.$store.dispatch('FETCH_SMART_FIELD_CODE_LIST');
        let bizProms = [];
        let promiseList = [];
        let majorList = [];
        let smartList = [];

        bizProms.push(this.$store.dispatch("FETCH_SSOV_DEPT_LIST"));
        bizProms.push(this.$store.dispatch("FETCH_BIZ_LIST"));
        Promise.all(bizProms).then(()=> {

            let majorBureauMap = gripUtil.toDict(this.ssovDeptList, 'deptId');
            let majorBureauNmMap = gripUtil.toDict(this.ssovDeptList, 'deptName');
            let bizList = this.bizList;
            bizList.forEach((biz) => {
                // 사업목록중 스마트가 아닌 경우
                if(biz.val22 !== 'S') {
                    if(biz.val19 === '공약') {
                        promiseList.push(biz);
                    } else if(biz.val19 === '역점') {
                        let deptNm = biz.val8;
                        if(typeof majorBureauNmMap[deptNm] !== $_TYPE.UNDEF ) {

                            let dept = majorBureauNmMap[deptNm];
                            let upperDeptId = dept.upperDeptId;
                            let upperDept = majorBureauMap[upperDeptId];

                            if($_CD.TOP_DEPT_CODE == upperDeptId) {
                                biz.upperDeptId = '32201190000';
                                biz.upperDeptNm = '행정국';
                                biz.upperDeptRank = '60';
                                biz.deptRank = dept.deptRank;
                            } else {
                                biz.upperDeptId = upperDeptId;
                                biz.upperDeptNm = upperDept.deptName;
                                biz.upperDeptRank = upperDept.deptRank;
                                biz.deptRank = dept.deptRank;
                            }
                        }
                        majorList.push(biz);
                    }
                }
                if(biz.val22 === 'S') {
                    smartList.push(biz);
                }
            });
            majorList = majorList.sort(function(pre, cur){
                return Number(pre.upperDeptRank) > Number(cur.upperDeptRank) ? 1 : Number(pre.upperDeptRank) < Number(cur.upperDeptRank) ? -1 : 0;
            });
            // 사업폐지 예외처리
            majorList = majorList.filter(d=>{
                if(d.val1 !== '469'){
                    return true;
                }
            });
            this.$store.dispatch('SET_PROMISE_LIST', promiseList);
            this.$store.dispatch('SET_MAJOR_LIST', majorList);
            this.$store.dispatch('SET_SMART_LIST', smartList);
            this.$store.dispatch('SET_MAJOR_MAP', gripUtil.toMap(majorList, 'upperDeptId'));

            // this.$store.dispatch('FETCH_LATEST_BRIEFING');
            // this.$store.dispatch('FETCH_LATEST_COVID_NEWS');
            this.$store.dispatch('FETCH_PROMISE_INFO_MAP');
            this.$store.dispatch('FETCH_SMART_INFO_MAP');
            this.$store.dispatch("FETCH_VIDEO_NEWS_LIST");
            this.$store.dispatch("FETCH_OPENAPI_GRID_DATA");
            this.$store.dispatch('FETCH_WORK_INCRUDE_INFO', 8);
        });
    },
    methods: {
        getRealtimeData(){
            // this.$store.dispatch('FETCH_REALTIME_SUMMARY_LIST');
            let now = new Date();
            now.setDate(now.getDate() - 0);
            let nowStr = now.format('yyyyMMdd');

            // 재난안전 (돌발이랑 동일한 조건으로 맞추기 위해 intervalDay=1은 24시기 때문에 날짜 추가)
            let q = 'stateMode=1&intervalDay=1&searchFromDate=' + nowStr + '000000&searchToDate=' + nowStr + '235959';
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                q = 'stateMode=1&intervalDay=999&searchFromDate=20210830000000&searchToDate=20210830235959';
            }
            this.$store.dispatch('FETCH_SAFETY_LIST', q);
            this.$store.dispatch('FETCH_SAFETY_TODAY_LIST');

            // 돌발
            q = 'whereNot=val2::4&whereLike=val4::' + encodeURIComponent('강남구') + '&searchActivityYn=1&whereStartLike=basdtVal::' + nowStr;
            this.$store.dispatch('FETCH_ACCIDENT_LIST', q);

            // 대기
            let poms = [];
            poms.push(this.$store.dispatch('FETCH_AIR_HJD_SENSOR_LIST'));
            Promise.all(poms).then(() => {
                this.$store.dispatch('FETCH_RAINFALL_LIST');
                this.$store.dispatch('FETCH_DONG_RAINFALL_INFO');
                this.$store.dispatch('FETCH_WATER_LEVEL_LIST', 'searchMaxBaseColumns=basdtVal&where=val4::101');
                this.$store.dispatch('FETCH_AIR_FORECAST_LIST');
            });
            // this.$store.dispatch('FETCH_AIR_HJD_SENSOR_LIST');

            // 상수도
            this.$store.dispatch('FETCH_SEOUL_HJD_CODE_LIST');
            this.$store.dispatch('FETCH_WATER_QUALITY_LIST');

            // 코로나
            // this.$store.dispatch('FETCH_COVID_SEOUL');  // 74
            // this.$store.dispatch('FETCH_COVID_GANGNAM_LIST');
            // this.$store.dispatch('FETCH_COVID_ISOLATION_LIST');
            // this.$store.dispatch('FETCH_COVID_CHECKUP_LOC_LIST');
            // this.$store.dispatch('FETCH_COVID_GU_SUMMARY_LIST');


            // this.$store.dispatch('FETCH_COVID_DAY_SEOUL_LIST');  // 702

            this.$store.dispatch("FETCH_SAFETY_GROUP_LIST");
            this.$store.dispatch("FETCH_ACCIDENT_GROUP_LIST");

            // 행정안전부 재난문자
            this.$store.dispatch("FETCH_DISASTER_TXT");
            // 5분마다 갱신
            setInterval(() => this.$store.dispatch('FETCH_DISASTER_TXT'), 1000 * 60 * 5);
        },
    },
};
</script>
